import "core-js/modules/es.object.get-own-property-descriptor.js";
import _objectSpread from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/createClass";
import _applyDecoratedDescriptor from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class;

import { lock } from '@/util/decorator';
import { checkRes, RequestLogicError } from '@tencent/Coa';
import env from '@tencent/vft-common/env';
import { request } from './util'; // 魔方链接

var baseUrl = '//activity.video.qq.com/fcgi-bin/asyn_activity';

var _ref = window.setting.魔方配置 || {},
    秒杀活动ID = _ref.秒杀活动ID,
    秒杀模块ID = _ref.秒杀模块ID,
    抽奖活动ID = _ref.抽奖活动ID,
    抽奖模块ID = _ref.抽奖模块ID,
    预约模块ID = _ref.预约模块ID; // 配置信息


var config = {
  actId: 抽奖活动ID,
  reserve: 预约模块ID,
  lottery: 抽奖模块ID
};
var MagicService = (_class = /*#__PURE__*/function () {
  function MagicService() {
    _classCallCheck(this, MagicService);
  }

  _createClass(MagicService, null, [{
    key: "doKill",
    value: function doKill() {
      var options = {
        type: 100138,
        option: 100,
        act_id: 秒杀活动ID,
        module_id: 秒杀模块ID
      };
      return request({
        jsonp: true
      })(baseUrl, options);
    }
  }, {
    key: "getKillInfo",
    value: function getKillInfo() {
      var options = {
        type: 100138,
        option: 104,
        act_id: 秒杀活动ID,
        module_id: 秒杀模块ID
      };
      return request({
        retry: 1,
        jsonp: true,
        checkRes: checkRes(function (res) {
          if (+res.ret === 0 || +res.ret === -1001) {
            return res;
          }

          throw new RequestLogicError(res.msg, res.ret, res);
        })
      })(baseUrl, options);
    }
  }, {
    key: "hasBookAct",
    value: function hasBookAct() {
      var options = {
        type: 30,
        option: 3,
        act_id: config.actId,
        module_id: config.reserve
      };
      return request({
        retry: 1,
        jsonp: true
      })(baseUrl, options);
    }
  }, {
    key: "bookAct",
    value: function bookAct() {
      var options = {
        type: 30,
        option: 104,
        act_id: config.actId,
        module_id: config.reserve
      };
      return request()(baseUrl, options);
    }
  }, {
    key: "getLotteryInfo",
    value: function getLotteryInfo() {
      var options = {
        type: 21,
        option: 101,
        act_id: config.actId,
        module_id: config.lottery
      };
      return request()(baseUrl, options);
    }
  }, {
    key: "lottery",
    value: function lottery() {
      var options = {
        type: 21,
        option: 100,
        act_id: config.actId,
        module_id: config.lottery
      };
      return request()(baseUrl, options);
    }
  }, {
    key: "getLotteryList",
    value: function getLotteryList() {
      var options = {
        type: 27,
        option: 3,
        act_id: config.actId,
        is_filter_mod: 1,
        module_id: config.lottery
      };
      return request()(baseUrl, options);
    }
  }, {
    key: "openVip",
    value: function openVip(data) {
      var options = _objectSpread({
        type: 23,
        option: 3,
        act_id: 111073
      }, data);

      if (env.isApp && env.isIpad) {
        options.platform = 4;
      }

      return request()(baseUrl, options);
    }
  }, {
    key: "getSvipOpenMod",
    value: function getSvipOpenMod() {
      var options = {
        type: 100115,
        option: 1,
        act_id: 111073,
        module_id: 132372
      };
      return request()(baseUrl, options);
    }
  }, {
    key: "lotteryFlowList",
    value: function lotteryFlowList() {
      var options = {
        type: 21,
        option: 105,
        act_id: config.actId,
        module_id: config.lottery,
        flow_len: 10
      };
      return request()(baseUrl, options);
    }
  }]);

  return MagicService;
}(), (_applyDecoratedDescriptor(_class, "doKill", [lock], Object.getOwnPropertyDescriptor(_class, "doKill"), _class), _applyDecoratedDescriptor(_class, "getKillInfo", [lock], Object.getOwnPropertyDescriptor(_class, "getKillInfo"), _class), _applyDecoratedDescriptor(_class, "hasBookAct", [lock], Object.getOwnPropertyDescriptor(_class, "hasBookAct"), _class), _applyDecoratedDescriptor(_class, "bookAct", [lock], Object.getOwnPropertyDescriptor(_class, "bookAct"), _class), _applyDecoratedDescriptor(_class, "getLotteryInfo", [lock], Object.getOwnPropertyDescriptor(_class, "getLotteryInfo"), _class), _applyDecoratedDescriptor(_class, "lottery", [lock], Object.getOwnPropertyDescriptor(_class, "lottery"), _class), _applyDecoratedDescriptor(_class, "getLotteryList", [lock], Object.getOwnPropertyDescriptor(_class, "getLotteryList"), _class)), _class);
export default MagicService;